module.exports = __webpack_public_path__ + "img/about-vision.07fca2de.png";